export default {
    setPasteActionsinfo(state, payload) {
        state.pasteActionsinfo = payload
    },
    unsetPasteActionsinfo(state) {
        state.pasteActionsinfo = null
    },
    setNewUpdatesPageData(state,payload){
        state.newUpdates.push(payload)
    },
    unsetNewUpdatesPageData(state,payload){
        state.newUpdates = state.newUpdates.filter(e => e._id != payload._id)
    }
};